/* eslint-disable */ import { assertBoolean, assertNumber, attributeSwitchComponent, detailComponent, entityHeaderComponent, memoEval, sceneEntityPropertiesComponent, sceneEntitySelectHotspotComponent, sketchingLineComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const deckSectionComponents = [
    attachComponent.withComponent(detailComponent, 'main', true).withEntity('DeckSection').attach(memoEval(()=>[], ()=>({
            title: 'Side A',
            subtitle: '',
            description: 'Flat surface'
        }))),
    attachComponent.withComponent(sketchingLineComponent, 'main', true).withEntity('DeckSection').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.length,
            self.angle
        ], (x, y, length, angle)=>({
            x: x,
            y: y,
            length: length,
            angle: angle,
            key: 'main'
        })), (state)=>{
        assertNumber(state.x);
        assertNumber(state.y);
        assertNumber(state.length);
        assertNumber(state.angle);
        return {
            x: state.x,
            y: state.y,
            length: state.length,
            angle: state.angle
        };
    }),
    attachComponent.withComponent(sketchingLineComponent, 'read', true).withEntity('DeckSection').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.length,
            self.angle
        ], (x, y, length, angle)=>({
            x: x,
            y: y,
            length: length,
            angle: angle,
            key: 'viewmode'
        })), (state)=>{
        assertNumber(state.x);
        assertNumber(state.y);
        assertNumber(state.length);
        assertNumber(state.angle);
        return {
            x: state.x,
            y: state.y,
            length: state.length,
            angle: state.angle
        };
    }),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'main', true).withEntity('DeckSection').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ],
        toolStates: [
            'Selection'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$centerX
        ], ($centerX)=>({
            offsetX: $centerX,
            offsetZ: 100
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'main', true).withEntity('DeckSection').attach(memoEval(()=>[], ()=>({}))),
    attachComponent.withComponent(attributeSwitchComponent, 'balustrade', true).withEntity('DeckSection').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.balustrade
        ], (balustrade)=>({
            value: balustrade
        })), (state)=>{
        assertBoolean(state.value);
        return {
            balustrade: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'sketching', true).withEntity('DeckSection').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.angle
        ], (x, y, angle)=>({
            offsetX: x,
            offsetZ: y,
            offsetY: 0,
            rotationY: angle
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'main', true).withEntity('DeckSection').withGradualFilter({
        viewStates: [
            '3dView'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.$levelHeight,
            self.angle
        ], (x, y, $levelHeight, angle)=>({
            offsetX: x,
            offsetZ: y,
            offsetY: $levelHeight,
            rotationY: angle
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'mainFloorPlan', true).withEntity('DeckSection').withGradualFilter({
        navigationStates: [
            'Properties',
            'Summary'
        ],
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.$levelHeight,
            self.angle
        ], (x, y, $levelHeight, angle)=>({
            offsetX: x,
            offsetZ: y,
            offsetY: $levelHeight,
            rotationY: angle
        })))
];

//# sourceMappingURL=deck-section.js.map